// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

// Import utilities
const {
	isEmpty
} = _uo.utility;

class RecipeNotices {
	constructor() {
		// Get main element
		this.elements = {
			container: $( '#uo-uap-notices' ),
		};

		// Check if the container exists
		// If not, then create it
		if ( this.elements.container.length == 0 ) {
			this.createContainer();
			this.elements.container = $( '#uo-uap-notices' );
		}

		// Empty the container
		this.emptyContainer();

		// Create warning
		this.createWarning();

		// Check if error mode is enabled
		if ( UncannyAutomator.recipe.errorMode ) {
			// Create error
			this.createError();
		}
	}

	emptyContainer() {
		this.elements.container.empty();
	}

	createContainer() {
		/* Create notice containers */
		const noticeContainer = $( '<div/>', { id: 'uo-uap-notices', class: 'uap' } );
		$( '#uap-publish-metabox' ).prepend( noticeContainer );
	}

	createError() {
		// Check if we have to create the notice
		if ( ! isEmpty( UncannyAutomator.recipe.message.error ) ) {
			// Create error container
			const notice = $( '<div/>', { class: 'uo-notice uo-notice--error' } ).text(
				UncannyAutomator.recipe.message.error
			);

			this.elements.container.append( notice );
		}
	}

	createWarning() {
		// Check if we have to create the notice
		if ( ! isEmpty( UncannyAutomator.recipe.message.warning ) ) {
			const notice = $( '<div/>', { class: 'uo-notice uo-notice--warning' } ).text(
				UncannyAutomator.recipe.message.warning
			);

			this.elements.container.append( notice );
		}
	}
}

export default RecipeNotices;
